window.addItem = function addItem(variantId) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({ quantity: 1, id: variantId }),
  })
    .then((response) => response.json())
    .then(cart =>{
      refreshCart();
    })
}

window.clearCart =  function clearCart(variantIds, callback) {
  const items = {};
  variantIds.forEach(element => (items[element] = 0));
  fetch('/cart/update.js', {
    method: 'POST',
    credentials: "same-origin",
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({updates: items})
  })
    .then((response) => response.json())
    .then(callback)
    .catch(err => console.log(err.responseText));
}
//Init Submit Gifts when cart refreshed
let cartData = null;

function getCart() {
  return fetch(`/cart.js`)
    .then(function(response) {
      return response.json();
    })
    .then(data => {
      cartData = data;
    })
    .catch(error => {
      console.error(error);
    });
}

//add product shipping insurance
window.ShippingBar = function ShippingBar() {
  var speed = 30;
  var items = document.querySelectorAll(".cart-rewards .progress_bar .progress_bar_item");
  items.forEach(function (item) {
    var progressBar = item.querySelector(".cart-rewards .progress");
    var itemValue = progressBar.dataset.progress;
    if (progressBar.classList.contains('progress--no-animate')) {
      progressBar.style.width = itemValue + "%";
    } else {
      var i = 0;
      var value = item;

      var count = setInterval(function () {
        if (i <= itemValue) {
            var iStr = i.toString();
            progressBar.style.width = iStr + "%";
        } else {
            clearInterval(count);
        }
        if (i >= 100) {
            clearInterval(count);
        }
      i++;
      }, speed);
    }
  });
}
ShippingBar();
window.checkShoppingInsurance = function checkShoppingInsurance(){
  let input_insurance = document.querySelector('.cart-shipping-insurance input');
  if(!input_insurance){
    return
  }
  input_insurance.addEventListener("change", function(event) {
    if(this.checked == true){
      addItem(parseInt(this.getAttribute('data-product')))
    }else{
      clearCart([parseInt(input_insurance.getAttribute('data-product'))], function() {
        refreshCart();
      })
    }
  })
  getCart().then(() => {
    const item = cartData.items.find(item => item.id === parseInt(input_insurance.getAttribute('data-product')));
    const idExists = !!item;
    idExists ? input_insurance.checked = true : '';
  });
}

window.checkGiftProduct = function(callback) {
  if (window.giftProduct) {
    getCart().then(() => {
      if (cartData) {
        const item = cartData.items.find(item => item.id === window.giftProduct)
        if (item) {
          if (cartData.item_count === 1 || cartData.total_price === 0) {
            clearCart([window.giftProduct], callback)
          }
        } else if (cartData.total_price > 0) {
          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ quantity: 1, id: window.giftProduct }),
          }).then(() => callback && callback())
        }
      }
    })
  }
}

window.displayDonationMessageCartDrawer = function displayDonationMessageCartDrawer(){
  fetch('/cart.js', {
    method: 'GET'
  })
  .then(response => response.json())
  .then(cart => {
    const container = document.querySelector(".movember-container")
    if(container){
      if (cart.total_price >= 2000) {
        container.style.display = 'flex'
      } else {
        container.style.display = 'none'
      }
    }
  })
  .catch(error => {
    console.error('Error fetching cart:', error);
  });
}

//add cart note
window.addCartNote = function addCartNote(){
  let btnCheckout = document.querySelector('button[name="checkout"]');
  let input_note = document.querySelector('#changeFlavours');
  let addText = '🔄 user agrees to receive a different flavour';

  if(!input_note){
    return
  }
  let cartNote = 'null';
  function updateCartNote(removeText) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        note: removeText
      })
    })
  }
  getCart().then(() => {
    if(cartData.note === null || cartData.note === ""){
      cartNote = false;
    }else{
      cartNote = true;
      input_note.checked = true;
    }
  }).then(()=>{
    input_note.addEventListener("change", function() {
      if(this.checked === false && document.querySelector('#cartSpecialInstructions').value.length > 0){
        //document.querySelector('#cartSpecialInstructions').textContent = "";
        //document.querySelector('#cartSpecialInstructions').value = "";
        updateCartNote("")
      }else{
        //document.querySelector('#cartSpecialInstructions').value = document.querySelector('#cartSpecialInstructions').value + addText;
        updateCartNote(addText)
      }
    })
  })
}
window.cartSliderFormSubmit = function cartSliderFormSubmit(form, giftProducts){
  document.querySelectorAll(form).forEach(form =>{
    form.addEventListener("submit", function(event) {
      event.preventDefault();
      if(document.querySelector('.loader-container')){
        document.querySelector('.loader-container').classList.add('active')
      }
      if (event.submitter) {
        event.submitter.classList.add('working')
      }
      var productSelect = this.querySelector("select");
      var product_id = productSelect.value;
      if(giftProducts === true){
        window.upsellProductsIDs = window.upsellProductsIDs || [];
        clearCart(window.upsellProductsIDs, function() {
          addItem(product_id);
        });
      }else{
        addItem(product_id);
      }
    });
  });
}
window.cartSliderSelect = function cartSliderSelect(select){
  document.querySelectorAll(select).forEach(select =>{
    select.addEventListener("change", function(event) {
      event.preventDefault();
      let imgUrl = this.selectedOptions[0].getAttribute('data-upsell-image');
      let variantPrice = this.selectedOptions[0].getAttribute('data-upsell-price');
      let variantComparePrice = this.selectedOptions[0].getAttribute('data-upsell-compare-price');
      if(imgUrl != 'indefined'){
        const img = this.closest('[data-product-select]').querySelector('img')
        img.src = imgUrl;
        img.srcset = '';
      }
      if(variantPrice != 'indefined' && this.closest('[data-product-select]').querySelector('[data-price] span') != undefined){
        this.closest('[data-product-select]').querySelector('[data-price] span').innerText = variantPrice;
      }
      if(variantComparePrice != 'indefined' && this.closest('[data-product-select]').querySelector('[data-price] del') != undefined){
        this.closest('[data-product-select]').querySelector('[data-price] del').innerText = variantComparePrice;
      }
    })
  });
}

window.InitSubmit = function InitSubmit(){

  cartSliderFormSubmit(".cart-gift-product form.upsell", true)
  cartSliderSelect(".cart-gift-product form.upsell select")
  if(document.querySelectorAll('[data-delete-gift]') != undefined){
    document.querySelectorAll('[data-delete-gift]').forEach(item => {
      var data = {
        id: item.getAttribute('data-delete-gift'),
        quantity: 0
      };
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data),
      })
      .then(() =>{
        refreshCart();
      })
    });
  }
  ShippingBar();
  checkShoppingInsurance();
  checkGiftProduct(refreshCart);
  addCartNote();
}
if(document.querySelector('body.template-cart') != null){
  InitSubmit();
  checkGiftProduct();
}
